
import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { I18nService } from '@core/services/translate/i18n.service';
import { Subscription } from 'rxjs';
import { DATE_FORMAT } from '@core/services/translate/i18n.constants';

@Pipe({
    name: 'i18nDate',
    pure: false // required to update the value when the promise is resolved
})
export class I18nDatePipe implements PipeTransform, OnDestroy {

    private key = null;
    private value = '';
    private format = '';

    private subscription: Subscription = null;

    constructor(private i18n: I18nService, private cdRef: ChangeDetectorRef) { }

    transform(value: Date, format = DATE_FORMAT): string {

        // if we ask another time for the same key, return the last value
        if (this.key === value && format === this.format) {
            return this.value;
        }

        this.format = format;
        this.updateValue(value);

        this.unsubscribe();
        this.subscription = this.i18n.localeChange$.subscribe(
            () => {
                this.updateValue(value);
                this.cdRef.markForCheck();
            }
        );

        return this.value;
    }

    updateValue(key: Date): void {
        this.key = key;

        if (!key) {
            this.value = '';
            return;
        }

        if (!this.i18n.locale) {
            this.value = '';
            return;
        }

        try {
            this.value = this.i18n.formatDate(this.key, this.format);
        } catch {
            this.value = '';
        }


    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

    private unsubscribe(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
